exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".txt-deadline[data-v-1f64e395]{font-size:13px;color:#787878}input[data-v-1f64e395]{width:40px;margin:0 4px 0 16px}", ""]);

// exports
